"use client";

import RadioItem from "./RadioItem";
import { useRadioGroup } from "./RadioGroup";

export default function RadioCard({
    value,
    title,
    description,
    icon,
    rightContent,
    defaultBorder = false,
    hoverBorder = false,
    checkedBorder = false,
    checkedBackground = false,
    boldOnSelected = false,
    disabled = false,
    className = "",
}) {
    const group = useRadioGroup();
    const checked = group.value === value;

    const borderClass = checked && checkedBorder ? "border border-jmt-primary-800" : defaultBorder ? "border border-jmt-neutral-200" : "border border-transparent";
    const checkedBgClass = checked && checkedBackground ? "bg-jmt-neutral-100" : "bg-jmt-white";
    const hoverClass = hoverBorder ? "hover:border hover:border-jmt-neutral-200" : "";

    return (
        <button
            type="button"
            disabled={disabled}
            onClick={() => group.onChange(value)}
            className={`w-full flex items-start rounded-md p-3 gap-3 transition-all duration-200
            ${borderClass}
            ${checkedBgClass}
            ${hoverClass}
            ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
            ${className}
        `}
        >
            <div className="h-5 flex items-center">
                <RadioItem value={value} disabled={disabled} />
            </div>

            <div className="flex-1 flex flex-col gap-1">

                <div className="flex items-center justify-between min-h-5">
                    <div className="flex items-center gap-2 min-w-0">
                        {icon && <span className="shrink-0 flex items-center">{icon}</span>}
                        <h3 className={`text-[13px] leading-5 lg:text-sm ${checked && boldOnSelected ? "font-bold" : "font-medium"}`}>
                            {title}
                        </h3>
                    </div>

                    {rightContent && (
                        <div className="text-xs lg:text-sm font-medium">
                            {rightContent}
                        </div>
                    )}
                </div>

                {description && (
                    <p className="text-xs text-jmt-neutral-500 pr-0 text-right">
                        {description}
                    </p>
                )}
            </div>
        </button>
    );
}
